import { ComponentBase } from "../core/ComponentBase.js";

export class DocumentationLink extends ComponentBase {
    static styles = `
        .documentation-link-btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            color: var(--bs-body-color);
            transition: color 0.15s ease-in-out, opacity 0.15s ease-in-out;
            cursor: pointer;
            padding: 0.25rem;
            border-radius: var(--ab-radius-sm);
        }
        .documentation-link-btn:hover {
            color: var(--bs-primary, #0d6efd);
            opacity: 0.9;
        }
        .documentation-link-btn i {
            font-size: var(--ab-text-lg);
        }
    `;

    constructor(config) {
        super(config);
        this._boundHandleRouteChanged = this.handleRouteChanged.bind(this);
        this.applyStyles();
    }

    static getDefaultConfig() {
        return {
            url: "/docs",
            target: "_blank",
            iconClass: "bi bi-question-circle",
            title: "Help & Documentation"
        };
    }

    async initialize() {
        // Listen to route changes for future contextual documentation lookup
        this.appClient.events.local.on("route-changed", this._boundHandleRouteChanged);
        await super.initialize();
    }

    render() {
        if (!this.container) {
            this.container = document.createElement("a");
            this.container.className = "documentation-link-btn";
        }

        const currentRoute = this.appClient.layoutEngine?.currentRoute || "";
        this.container.href = this.getDocumentationUrl(currentRoute);
        this.container.target = this.config.target;
        this.container.title = this.t(this.config.title) || this.config.title;
        
        // Simple HTML layout obeying standard bootstrap icon class
        this.container.innerHTML = `<i class="${this.escapeAttr(this.config.iconClass)}"></i>`;

        return this.container;
    }

    getDocumentationUrl(route) {
        // Points to /docs, but can be updated in the future to map specific routes/contextual paths
        return this.config.url;
    }

    handleRouteChanged(route) {
        // Force re-render to update the URL dynamically based on current route/context if needed
        this.render();
    }

    destroy() {
        this.appClient.events.local.off("route-changed", this._boundHandleRouteChanged);
        super.destroy();
    }
}
